export const ModalOpenFor = {
  Start_Up: "Start-up",
  Individual: "Individual",
};

export const SIGNUPFORM = {
  nm: "",
  eml: "",
  phNo: "",
  city: "",
  state: "",
};
export const SIGNUPFORMERR = {
  nm: undefined,
  eml: undefined,
  phNo: undefined,
  city: undefined,
};
